module.exports = __webpack_public_path__ + "webpc/img/icon_nolink.f6eb4c1f.png";